function fnServicesHero(i, oSection) {
  gsap.context(() => {
    const img = oSection.querySelector(".title .img");
    const scale =
      window.innerWidth > window.innerHeight
        ? window.innerWidth / img.offsetWidth
        : window.innerHeight / img.offsetHeight;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: oSection,
        pin: true,
        pinSpacing: false,
        start: "top top",
        endTrigger: document.querySelector("section.brands"),
        end: "bottom bottom",
        scrub: true,
      },
    })

    tl.to("img", {
      y: -img.offsetTop,
      x: window.innerWidth > window.innerHeight ? -img.offsetLeft : -img.offsetLeft - (window.innerWidth - (img.offsetHeight * img.offsetWidth/img.offsetHeight)),
      scale: scale,
      ease: "none",
    });

    tl.to("img", {}, '+=2')
  }, oSection);
}
